import { Link } from 'react-router-dom'

import LeftArrowIcon from 'ui-component-library/icons/arrow-left.svg'
import RightArrowIcon from 'ui-component-library/icons/arrow-right.svg'
import ArrowButton from './ArrowButton'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import style from './style.scss'

type Props = {
  className?: string
  dateText: string
  dayText: string
  onPreviousClick?: () => void
  previousUrl?: string
  previousDayLabelText?: string
  onNextClick?: () => void
  nextUrl?: string
  nextDayLabelText?: string
  url?: string
}

function DailyModuleDateNavigation({
  dayText,
  dateText,
  previousUrl,
  onPreviousClick,
  previousDayLabelText,
  nextUrl,
  onNextClick,
  nextDayLabelText,
  url,
}: Props) {
  return (
    <div className={style.wrapper}>
      <ArrowButton
        className={style.leftArrow}
        Icon={LeftArrowIcon}
        text={previousDayLabelText}
        url={previousUrl}
        onClick={onPreviousClick}
      />
      <div className={style.dayText}>{dayText}</div>
      {url ? (
        <Link to={url}>
          <HeadlineTwo className={style.dateText}>{dateText}</HeadlineTwo>
        </Link>
      ) : (
        <HeadlineTwo className={style.dateText}>{dateText}</HeadlineTwo>
      )}

      <ArrowButton
        className={style.rightArrow}
        Icon={RightArrowIcon}
        text={nextDayLabelText}
        url={nextUrl}
        onClick={onNextClick}
      />
    </div>
  )
}

export default DailyModuleDateNavigation
